<h2 mat-dialog-title>About ComplyTRI</h2>
<mat-dialog-content>
  <p><strong>Version:</strong> {{ version }}</p>
  <p>ComplyTRI is a comprehensive compliance management system for TRI reporting.</p>
  <p>&copy; {{ currentYear }} ComplyTRI. All rights reserved.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>